const primaryMain = '#BE0F34';
const primaryMainOpacity = 'rgba(190, 15, 52, 0.9)';
const secondaryMain = '#000000';
const secondaryMainOpacity = 'rgba(0, 0, 0, 0.5)';
const secondaryLight = '#8F010A';
const tertiaryMain = '#000000';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
